import { RowType } from '@cmps/ng-kit';

import { KpiType } from '../coaching-insight/insight-widget/model/kpi-type.model';
import { createReducer } from '../store.model';

import { getOaTrendDataSet } from './functions/get-oa-trend-data-set.function';
import { OaScoreType } from './models/oa-score-type.enum';
import {
    ActionType,
    CloseAllCharts,
    Reload,
    ReloadResult,
    RootClearStateAction,
    SelectPeerGroup,
    SetChartData,
    ToggleSelectedRow,
} from './my-coaching-card.action';
import { CoachingCardState, defaultState } from './my-coaching-card.state';
import { handleReloadResult } from './state/handle-reload-result.function';
const { builder, reducer } = createReducer<ActionType, CoachingCardState>(
    defaultState(),
);

builder.add<Reload>(ActionType.MY_COACHING_CARD__ROOT__RELOAD, (state) => {
    return {
        ...state,
        pending: {
            ...state.pending,
            reload: true,
            hasData: true,
        },
    };
});

builder.add<ReloadResult>(
    ActionType.MY_COACHING_CARD__ROOT__RELOAD_RESULT,
    handleReloadResult,
);

builder
    .add<SelectPeerGroup>(
        ActionType.MY_COACHING_CARD_SELECT_PEER_GROUP,
        (state, action) => {
            const selectedPeerGroup = action.payload.selectedGroup;
            const isTypeFLOA = action.payload.rowType === RowType.FLOA;
            const cardRowsData = state.cardItems?.find(
                (e) => e.type === RowType.OA,
            ).cardRowsData;
            const selectedRows: OaScoreType[] = [];

            const index = cardRowsData.findIndex(
                (e) => e.id === OaScoreType.OA,
            );
            cardRowsData[
                index
            ].dropdownMenuData?.dropdownMenuValues[1].subMenu.some(
                (e) => e.selected,
            );

            if (selectedPeerGroup !== OaScoreType.Peer_Compare) {
                cardRowsData.forEach((e) => {
                    if (e.id === selectedPeerGroup) {
                        e.rowData.isVisible = !(e.rowData.isVisible ?? false);
                    }
                });
            }

            cardRowsData[index].dropdownMenuData?.dropdownMenuValues.forEach(
                (e) => {
                    if (e.id === OaScoreType.Peer_Compare) {
                        e.subMenu?.forEach((item) => {
                            if (item.id === selectedPeerGroup) {
                                item.selected = !item.selected;
                            }
                        });
                        e.subMenu?.forEach((item) =>
                            item.selected ? selectedRows.push(item.id) : null,
                        );
                    }
                },
            );
            const oaTrendData = getOaTrendDataSet(
                state.oaSummary,
                selectedRows,
                isTypeFLOA,
            );

            return {
                ...state,
                cardRowsData,
                oaTrendData,
            };
        },
    )

    .add<SetChartData>(
        ActionType.MY_COACHING_CARD_SET_CHART_DATA,
        (state, action) => {
            const { rowType, rowIndex } = action.payload;
            let chartData;
            switch (rowType) {
                case RowType.MI2:
                    chartData = state.trendDataMap.get(
                        KpiType.MANAGEMENT_IMPROVEMENT_INDEX,
                    );
                    break;
                case RowType.FLMI2:
                    chartData = state.trendDataMap.get(
                        KpiType.FL_MANAGEMENT_IMPROVEMENT_INDEX,
                    );
                    break;
                case RowType.WP:
                    chartData = state.trendDataMap.get(
                        KpiType.WINNING_PERCENTAGE,
                    );
                    break;
                case RowType.FLWP:
                    chartData = state.trendDataMap.get(
                        KpiType.FL_WINNING_PERCENTAGE,
                    );
                    break;
                default:
                    chartData = state.trendDataMap.get(
                        KpiType.OPPORTUNITY_ALIGNMENT,
                    );
            }
            return {
                ...state,
                chartDataByRow: {
                    ...state.chartDataByRow,
                    [rowIndex]: chartData,
                },
            };
        },
    )

    .add<ToggleSelectedRow>(
        ActionType.MY_COACHING_CARD_TOGGLE_SELECTED_ROW,
        (state, action) => {
            const { rowIndex } = action.payload;
            const selectedRows = {
                ...state.selectedRows,
                [rowIndex]: !state.selectedRows[rowIndex] ?? true,
            };

            return {
                ...state,
                selectedRows,
            };
        },
    )

    .add<CloseAllCharts>(
        ActionType.MY_COACHING_CARD_CLOSE_ALL_CHARTS,
        (state) => {
            const newSelectedRows = Object.keys(state.selectedRows).reduce(
                (acc, key) => {
                    acc[key] = false;
                    return acc;
                },
                {},
            );

            return {
                ...state,
                selectedRows: newSelectedRows,
            };
        },
    );

builder.add<RootClearStateAction>(
    ActionType.MY_COACHING_CARD_ROOT__CLEAR_STATE,
    () => {
        return defaultState();
    },
);

export const coachingCardReducer = reducer;
